module.exports = __webpack_public_path__ + "static/img/6.650c89e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/9/zh/6.png
// module id = xxZq
// module chunks = 0